// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingAnalytics_DeviceDetailResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/messaging_analytics/device_detail/{whatsappfranquia_id}
 *
 * Returns the detailed messaging metrics for a single device (WhatsApp or
 * Instagram). The dados shape is the metrics map built by
 * MessagingAnalyticsService::getDeviceDetail() (computeMetrics +
 * fetchChatMetrics + composite score), plus the score_performance,
 * whatsappfranquia_id and device_name keys injected by the controller.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessagingAnalytics_DeviceDetailResponseDados {
mensagens_enviadas: number
mensagens_recebidas: number
conversas_ativas: number
conversas_novas: number
total_chats: number
chats_nao_lidos: number
chats_sem_resposta: number
score: number
score_performance: number
whatsappfranquia_id: number
device_name: string
}

export type MessagingAnalytics_DeviceDetailResponse = ApiResponse<MessagingAnalytics_DeviceDetailResponseDados>;

registerResponseContract('MessagingAnalytics_DeviceDetailResponse', {
  mensagens_enviadas:  { type: 'number',  required: true },
  mensagens_recebidas: { type: 'number',  required: true },
  conversas_ativas:    { type: 'number',  required: true },
  conversas_novas:     { type: 'number',  required: true },
  total_chats:         { type: 'number',  required: true },
  chats_nao_lidos:     { type: 'number',  required: true },
  chats_sem_resposta:  { type: 'number',  required: true },
  score:               { type: 'number',  required: true },
  score_performance:   { type: 'number',  required: true },
  whatsappfranquia_id: { type: 'number',  required: true },
  device_name:         { type: 'string',  required: true },
})
